import { render } from "./product-subscription-perks.vue?vue&type=template&id=567f2506"
import script from "./product-subscription-perks.vue?vue&type=script&lang=js"
export * from "./product-subscription-perks.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Shopify/clients/sneak/.worktrees/pdp-golive-uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__